import React from "react";
import { Link } from "react-router-dom";
import { Truck, PackageCheck, Globe } from "lucide-react";
import InfoPage from "./Infopage";
import { Helmet } from "react-helmet-async";

// TODO: replace with your real rates and timeframes.
const OPTIONS = [
  {
    name: "Standard delivery",
    time: "2–4 business days",
    cost: "Free over 10000",
  },
  {
    name: "Express delivery",
    time: "2hrs- 1business days",
    cost: "Price based on destination",
  },
  { name: "Store pickup", time: "Ready in minutes", cost: "Free" },
];

function Shipping() {
  return (
    <InfoPage
      title="Shipping"
      intro="How and when your order gets to you. Delivery times start once your order is packed."
    >
      <Helmet>
        <title>Shipping & Delivery in Nairobi, Kenya | Ninety One</title>
        <meta
          name="description"
          content="Delivery options for Ninety One orders: standard delivery in 2-4 business days, express delivery within hours in Nairobi, and free standard shipping on larger orders."
        />
        <link rel="canonical" href="https://ninetyone.co.ke/shipping" />
      </Helmet>
      <section className="info-section">
        <h2 className="info-h2">Delivery options</h2>
        <div className="info-table-wrap">
          <table className="info-table">
            <thead>
              <tr>
                <th>Option</th>
                <th>Delivery time</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {OPTIONS.map((o) => (
                <tr key={o.name}>
                  <td data-label="Option">{o.name}</td>
                  <td data-label="Delivery time">{o.time}</td>
                  <td data-label="Cost">{o.cost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="info-section info-grid">
        <div className="info-item">
          <span className="info-icon">
            <PackageCheck aria-hidden="true" />
          </span>
          <h3 className="info-h3">Order processing</h3>
          <p>
            Orders placed before 16:00 ship the same day. Orders placed later,
            or on weekends and public holidays, ship the next business day.
          </p>
        </div>
        <div className="info-item">
          <span className="info-icon">
            <Truck aria-hidden="true" />
          </span>
          <h3 className="info-h3">Tracking</h3>
          <p>
            You'll get a notification with a tracking link as soon as your order
            leaves our warehouse.
          </p>
        </div>
        <div className="info-item">
          <span className="info-icon">
            <Globe aria-hidden="true" />
          </span>
          <h3 className="info-h3">International orders</h3>
          <p>
            We ship to selected countries. Duties and taxes are set by your
            country and are paid on delivery.
          </p>
        </div>
      </section>

      <section className="info-section">
        <h2 className="info-h2">If something goes wrong</h2>
        <p className="info-text">
          If your order is late, damaged or missing, contact us within 7 days of
          the expected delivery date and we'll fix it. Have your order number
          ready.
        </p>
        <div className="info-actions">
          <Link to="/contact-us" className="info-btn info-btn--primary">
            Contact us
          </Link>
          <Link to="/return-policy" className="info-btn info-btn--secondary">
            Returns policy
          </Link>
        </div>
      </section>
    </InfoPage>
  );
}

export default Shipping;
